import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 27.918 27.937" {...props}>
      <defs>
        <style>
          {`.prefix__prefix__cls-1menuseverityicon{fill:none;stroke:${props.color};stroke-linecap:round;stroke-linejoin:round}`}
        </style>
      </defs>
      <g
        id="prefix__prefix__Group_2513"
        data-name="Group 2513"
        transform="translate(-2316.578 -621.212)"
      >
        <path
          id="prefix__prefix__Path_3554"
          d="M2573.289 727.2a3.707 3.707 0 004.033-1c1.252-2.024 2.35-.419 2.725.837s.336 3.2-1.821 2.193a3.708 3.708 0 00-3.92 1.377"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3554"
          transform="translate(-237.211 -95.839)"
        />
        <path
          id="prefix__prefix__Path_3555"
          d="M2507.723 638.886a8.941 8.941 0 00-1.99-1.964 2.748 2.748 0 011.56-1.945c2.236-.814.888-2.216-.264-2.838s-3.064-.981-2.518 1.335a2.75 2.75 0 01-.772 2.371 8.931 8.931 0 00-2.813-.592"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3555"
          transform="translate(-170.21 -9.21)"
        />
        <path
          id="prefix__prefix__Path_3556"
          d="M2381.667 873a8.953 8.953 0 001.99 1.964 2.748 2.748 0 01-1.559 1.945c-2.237.814-.889 2.216.264 2.838s3.063.981 2.518-1.335a2.751 2.751 0 01.772-2.371 8.927 8.927 0 002.813.592"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3556"
          transform="translate(-59.073 -232.647)"
        />
        <path
          id="prefix__prefix__Path_3557"
          d="M2323.01 804.322a3.707 3.707 0 01-3.92 1.377c-2.157-1.006-2.195.939-1.82 2.194s1.472 2.86 2.725.837a3.707 3.707 0 014.033-1"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3557"
          transform="translate(0 -169.064)"
        />
        <path
          id="prefix__prefix__Path_3558"
          d="M2412.06 629.114a3.628 3.628 0 00-1.036-4.219c-2.173-1.292-.144-2.545 1.216-2.951s3.744-.471 2.635 1.8a3.642 3.642 0 001.447 4.1"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3558"
          transform="translate(-86.088)"
        />
        <path
          id="prefix__prefix__Path_3559"
          d="M2323.567 702.364a8.924 8.924 0 01.588-2.733 2.749 2.749 0 00-2.371-.772c-2.316.546-1.958-1.366-1.335-2.518s2.024-2.5 2.838-.264a2.748 2.748 0 001.946 1.559 8.928 8.928 0 012.029-2.037"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3559"
          transform="translate(-2.678 -67.725)"
        />
        <path
          id="prefix__prefix__Path_3560"
          d="M2524.8 803.45a1.779 1.779 0 10-1.957 2.762"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3560"
          transform="translate(-189.35 -167.594)"
        />
        <path
          id="prefix__prefix__Path_3561"
          d="M2496.818 737.3a1.779 1.779 0 10-1.2 2.213 1.779 1.779 0 001.2-2.213z"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3561"
          transform="translate(-163.183 -105.836)"
        />
        <path
          id="prefix__prefix__Path_3562"
          d="M2415.584 744.858a1.779 1.779 0 10-1.2 2.213 1.778 1.778 0 001.2-2.213z"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3562"
          transform="translate(-87.969 -112.831)"
        />
        <path
          id="prefix__prefix__Path_3563"
          d="M2446.137 819.226a1.779 1.779 0 10-1.2 2.213 1.779 1.779 0 001.2-2.213z"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3563"
          transform="translate(-116.257 -181.687)"
        />
        <path
          id="prefix__prefix__Path_3564"
          d="M2512.3 843.673h4.153a.663.663 0 00.481-1.035l-5.932-9.36a.556.556 0 00-.962 0l-5.932 9.36a.663.663 0 00.481 1.035h4.153"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Path 3564"
          transform="translate(-173.058 -195.617)"
        />
        <path
          id="prefix__prefix__Line_520"
          d="M0 0v4.743"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Line 520"
          transform="translate(2337.465 641.534)"
        />
        <path
          id="prefix__prefix__Line_521"
          d="M0 0v1.186"
          className="prefix__prefix__cls-1menuseverityicon"
          data-name="Line 521"
          transform="translate(2337.465 647.463)"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
